"use client";

import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <nav className="flex gap-6">
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/20 animate-pulse rounded" />
      </nav>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-row gap-6">
        {menuItems.slice(0, 5).map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-[var(--duration-medium)] relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[1px] after:bg-foreground-dark after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <footer id="footer" className="w-full bg-dark-background border-t border-border/20 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-foreground-dark/70 text-sm">
            © 2026 AMPKORE
          </div>
          
          <MenuProvider menu_id="36">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>
      </div>
    </footer>;
}